<script setup lang="ts">
  import PageLandscapeIcon from '@/shared/assets/icons/PageLandscapeIcon.svg';
  import PagePortraitIcon from '@/shared/assets/icons/ColumnVerticalIcon.svg';
  import { IconImage, Tooltip } from '@/shared/ui';

  interface Props {
    orientation?: 'portrait' | 'landscape';
  }

  const props = withDefaults(defineProps<Props>(), {
    orientation: 'portrait',
  });

  const emit = defineEmits<{
    (e: 'update:orientation', value: 'portrait' | 'landscape'): void;
  }>();
</script>

<template>
  <div class="flex items-center justify-center gap-1">
    <Tooltip content="Orientação vertical">
      <button
        class="flex cursor-pointer items-center justify-center rounded-md border border-[var(--color-gray-02)] text-[var(--color-gray-05)] transition-all duration-200 hover:border-[var(--color-gray-02)] hover:bg-[var(--color-gray-08)] hover:text-[var(--color-gray-07)]"
        :class="
          props.orientation === 'portrait'
            ? 'bg-[var(--color-gray-02)]'
            : 'bg-[var(--color-white-01)]'
        "
        data-testid="orientation-portrait-btn"
        @click="emit('update:orientation', 'portrait')"
      >
        <IconImage
          :src="PagePortraitIcon"
          alt="Retrato"
        />
      </button>
    </Tooltip>
    <Tooltip content="Orientação horizontal">
      <button
        class="flex cursor-pointer items-center justify-center rounded-md border border-[var(--color-gray-02)] text-[var(--color-gray-05)] transition-all duration-200 hover:border-[var(--color-gray-02)] hover:bg-[var(--color-gray-08)] hover:text-[var(--color-gray-07)]"
        :class="
          props.orientation === 'landscape'
            ? 'bg-[var(--color-gray-02)]'
            : 'bg-[var(--color-white-01)]'
        "
        data-testid="orientation-landscape-btn"
        @click="emit('update:orientation', 'landscape')"
      >
        <IconImage
          :src="PageLandscapeIcon"
          alt="Paisagem"
        />
      </button>
    </Tooltip>
  </div>
</template>
